import { v1 as uuidv1 } from 'uuid';
import { isEmpty, get, filter } from 'lodash';
import { getPromptFromHtml } from 'components/FormattedInput/helpers';
import { ANSWER_DEFAULT } from 'containers/QuestionnairePage/constants';
import {
  isItemFromCurrentRevision,
  isItemInsideGroup,
} from 'containers/Permissions/helpers';
import {
  COLUMN_NONE_OF_THESE,
  MATRIX_MIN_COLUMNS,
  COLUMN_DEFAULT,
} from './constants';

export const getEmptyRow = ({ isEmptyAnswer = true } = {}) => ({
  body: '',
  refId: uuidv1(),
  type: ANSWER_DEFAULT,
  isEmptyAnswer,
});

export const getEmptyColumn = ({
  body = '',
  alias = '',
  isEmptyAnswer = true,
  type = COLUMN_DEFAULT,
} = {}) => ({
  body,
  alias,
  refId: uuidv1(),
  type,
  isEmptyAnswer,
});

export const getEmptyMatrixAnswer = ({
  isEmptyAnswer = true,
  answerRefId = '',
} = {}) => ({
  refId: uuidv1(),
  answerRefId,
  beforeLabel: '',
  afterLabel: '',
  isEmptyAnswer,
});

export const isAnswerInvalid = (answer) => {
  const prompt = getPromptFromHtml(answer.body);
  return !answer.isEmptyAnswer && isEmpty(prompt);
};
export const isAnswerEmpty = (answer) => answer.isEmptyAnswer;

export const carriedForwardColumnsSelector = (columns) =>
  columns.filter(isCarriedForward);

export const isCarriedForward = (answer) => Boolean(answer.isCarriedForward);

export const hasOnlyDefaultScorepoints = (question) => {
  const scorepoints = get(question, 'scorepoints', []);
  return (
    scorepoints.length <= MATRIX_MIN_COLUMNS &&
    scorepoints.every((scorepoint) => {
      const prompt = getPromptFromHtml(scorepoint.body);
      return isAnswerEmpty(scorepoint) || isEmpty(prompt);
    })
  );
};

export const noneOfTheseColumnSelector = (columns = []) =>
  columns.find((col) => col.type === COLUMN_NONE_OF_THESE);

export const hasNoneOfTheseColumn = (columns) =>
  Boolean(noneOfTheseColumnSelector(columns));

export const filterVisibleColumns = (columns) =>
  columns?.length > 0
    ? columns.filter((col) => col.type !== COLUMN_NONE_OF_THESE)
    : [];

export const canAddItem = ({ isUnderEdit, itemToCheck }) => {
  if (!isUnderEdit) {
    return true;
  }

  if (isItemFromCurrentRevision({ itemToCheck })) {
    return true;
  }

  if (!isItemInsideGroup({ itemToCheck })) {
    return true;
  }

  return false;
};

export const canRemoveItem = ({ isUnderEdit, itemToCheck }) => {
  if (itemToCheck.isCarriedForward) {
    return false;
  }
  if (isUnderEdit && !isItemFromCurrentRevision({ itemToCheck })) {
    return false;
  }

  return true;
};

export const getActiveAnswerValues = (values) =>
  filter(
    values,
    ({ body, media }) => body || get(media, 'url', false) !== false,
  );

export const canEnableQuotasForAnswers = ({ answers = [] }) => {
  const allowedAnswers = getActiveAnswerValues(answers);
  const canEnableQuotas =
    allowedAnswers.length > 1 && allowedAnswers.length < 101;

  return canEnableQuotas;
};

export const canEnableQuotasForMatrixAnswers = ({ columns = [] }) => {
  const canEnableQuotas = columns.length > 1;

  return canEnableQuotas;
};
